import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Icon } from '@mgc/react-components';
import PropTypes from 'prop-types';
import MapPropTypes from '../../MapPropTypes';
import strings from '../../../strings';
import utils from '../../../utils';
import './TransactionHistory.scss';

export default class TransactionHistory extends Component {
    static propTypes = {
        transactions: PropTypes.arrayOf(MapPropTypes.TransactionProps),
        cancelOrder: PropTypes.func.isRequired,
    };

    _renderPopover(transaction, key) {
        const showWeeks =
            transaction.licenses.length > 0 &&
            transaction.licenses.find(({ weeks }) => weeks > 0);

        return (
            <Popover id={key}>
                <table className="table table-sm m-b-0">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Seats</th>
                            <th>Months</th>
                            {showWeeks && <th>{strings.weeks}</th>}
                            <th>Credits Used</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transaction.licenses.map((license, j) => (
                            <tr key={j}>
                                <td>{license.product.name}</td>
                                <td>{license.seats}</td>
                                <td>{license.duration}</td>
                                {showWeeks && <td>{license.weeks}</td>}
                                <td>{utils.formatPrice(license.amount)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {transaction.instructions && (
                    <div className="transaction-instructions text-mute">
                        <strong>{strings.specialInstructions}:</strong>{' '}
                        {transaction.instructions}
                    </div>
                )}
            </Popover>
        );
    }

    _renderUser(transaction) {
        const { user, type, lastModified } = transaction;

        if (!user || !user.email || type !== 'order') {
            return null;
        }

        return (
            <a
                href={`mailto:${user.email}?subject=${
                    strings.regardingOrder
                } ${utils.formatShortDate(lastModified)}`}
            >
                {user.email}
            </a>
        );
    }

    // _renderCancelButton(transaction) {
    // if (transaction.type === 'order') {
    //     return (
    //         <button
    //             type="button"
    //             className="close"
    //             aria-label="Close"
    //             onClick={() => this.props.cancelOrder(transaction)}
    //         >
    //             <span className="text-danger text-md" aria-hidden="true">
    //                 <Icon name="icon-cancel" />
    //             </span>
    //             <span className="sr-only">Close</span>
    //         </button>
    //     );
    // }

    // return null;
    // }

    _renderTransactionItem(transaction, key) {
        const buildPopover =
            transaction.licenses && transaction.licenses.length > 0;
        const result = (
            <tr key={key}>
                <td className="text-sm text-muted">
                    {utils.formatDate(transaction.lastModified)}
                </td>
                <td>
                    {transaction.description}
                    {buildPopover ? (
                        <span className="text-info">
                            {' '}
                            <Icon name="icon-bubble-lines2" />
                        </span>
                    ) : (
                        ''
                    )}
                </td>
                <td>{this._renderUser(transaction)}</td>
                <td className={`text-right ${utils.amountClass(transaction)}`}>
                    <b>{utils.formatPrice(transaction.amount)}</b>
                </td>
                {/*<td>{this._renderCancelButton(transaction)}</td>*/}
            </tr>
        );

        if (buildPopover) {
            return (
                <OverlayTrigger
                    key={key}
                    placement="top"
                    trigger={['hover', 'focus']}
                    overlay={this._renderPopover(transaction, key)}
                >
                    {result}
                </OverlayTrigger>
            );
        }

        return result;
    }

    /* we'll never need to repaint this. if the offer changes, the use will have
     *  to refresh the page anyway
     */
    shouldComponentUpdate() {
        return false;
    }

    _renderTable() {
        const { transactions } = this.props;

        if (transactions.length === 0) {
            return (
                <div className="p-a-md text-center text-mute">
                    <em>{strings.none}</em>
                </div>
            );
        }

        return (
            <table className="table table-hover m-b-0">
                <thead>
                    <tr>
                        <th className="text-xs text-uppercase">
                            {strings.date}
                        </th>
                        <th className="text-xs text-uppercase">
                            {strings.description}
                        </th>
                        <th className="text-xs text-uppercase">
                            {strings.user}
                        </th>
                        <th className="text-xs text-uppercase text-right">
                            {strings.creditsUsed}
                        </th>
                        {/*<th />*/}
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((t, i) =>
                        this._renderTransactionItem(t, i)
                    )}
                </tbody>
            </table>
        );
    }

    render() {
        return (
            <div className="transaction-history p-a-0">
                <div className="p-r-sm p-l-sm border-bottom">
                    <b>{strings.history}</b>
                </div>
                <div className="transaction-table">{this._renderTable()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Modals/TransactionModal/TransactionHistory.jsx